"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.LibraryHeader = void 0;
var react_1 = __importDefault(require("react"));
function mapSize(size) {
    if (size === void 0) { size = "lg"; }
    switch (size) {
        case "sm":
            return "text-lg text-blue-darker";
        case "md":
            return "text-2xl";
        case "lg":
            return "text-3xl text-grey-dark";
    }
}
var LibraryHeader = function (_a) {
    var children = _a.children, size = _a.size;
    return (react_1.default.createElement("h1", { className: "".concat(mapSize(size), " font-normal inline-block") }, children));
};
exports.LibraryHeader = LibraryHeader;
